module.exports = __webpack_public_path__ + "img/icon_data_delete.0.1.0_202508261531.png";